export default "__VITE_ASSET__CAvJLFwW__"